<template>
<TousRapports/>
</template>

<script>
import axios from 'axios'
import TousRapports from "@/components/rapports/dashboard/BoiteTousRapports.vue";
import {mapGetters} from "vuex";

export default {
  name: 'Consulter',
  components: {
    TousRapports,
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Rapports");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
    }
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.menu();
    },
  },
};
</script>